import React, { useState, createContext, useContext, useEffect } from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import Sidebar from "../components/Sidebar/Sidebar";
import Navbar from "../components/Navbar/Navbar";
import "../styles/main.scss";
import { useLocation } from "react-router-dom";
import { ROUTES } from "../constants/routes";
import ReusableModal from "../components/MUIComponent/Utlis/Modal/Modal";
import { ThemeProvider } from "../context/ThemeContext";
import { FlagsClassInitiate } from "../api/ClassSection/ClassSectionService";
import { useAuth } from "../hooks/useAuth";
import { useDispatch, useSelector } from "react-redux";
import { GetAllAcademicYearList } from "../api/SchoolService/SchoolService";
import { useSnackbar } from "../components/MUIComponent/FeedbackComponent/SnackBar/SnackbarContext";
import { getSchoolProfileSuccess } from "../features/schoolProfile/schoolProfileSlice";
const ModalContext = createContext();
export const useModal = () => useContext(ModalContext);

const MainLayout = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const theme = useTheme();
  const menuState = useSelector((state) => state.menu);
  const { schoolProfileData } = useSelector(state => state.schoolProfile);
  const [academicYearList, setAcademicYearDataList] = useState([]);

  const [classFlags, setClassFlags] = React.useState(null);
  const { user } = useAuth();
  const userRoleName = user?.roleName;
  const schoolID = user?.schoolID;
  const { showSnackbar } = useSnackbar();


  const [loading, setLoading] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [modalState, setModalState] = useState({
    open: false,
    component: null,
    props: {},
  });
  const ModalComponent = modalState.component;



  useEffect(() => {
    document.body.style.overflow = modalState.open ? "hidden" : "auto";
  }, [modalState.open]);

  useEffect(() => {
    if (!isMobile) {
      setSidebarOpen(true);
    } else {
      setSidebarOpen(false);
    }
  }, [isMobile]);

  useEffect(() => {
    if (!schoolID) return;

    const initiateClassFlags = async () => {
      try {
        const payload = { schoolID };
        const response = await FlagsClassInitiate(payload);
        if (response?.data?.length > 0) {
          setClassFlags(response.data[0]);
        }
      } catch (error) {
        return "";
      }
    };

    initiateClassFlags();
  }, [schoolID, menuState]);

  const allStepsCompleted =
    classFlags &&
    schoolID &&
    classFlags.isClassAvailable &&
    classFlags.isClassMapAvailable 
    // classFlags.isFeeMasterAvailable &&
    // classFlags.isFeeReminderAvailable &&
    // classFlags.isFeeAssignClassAvailable &&
    // classFlags.isFeeFrequencyAvailable;

  const adminShouldSetup =
    userRoleName === "Admin" &&
    classFlags &&
    !allStepsCompleted;

  const loginRoutes = [
    ROUTES.ADMINSIGNIN,
    ROUTES.ADMINFORGOTPASSWORD,
    ROUTES.ADMINVERIFYOTP,
  ];

  if (
    adminShouldSetup &&
    !loginRoutes.includes(location.pathname) &&
    location.pathname !== ROUTES.SYSTEMSETUPSCHOOL
  ) {
    window.location.replace(ROUTES.SYSTEMSETUPSCHOOL);
    return null;
  }
  const hideSidebarRoutes = [
    ROUTES.STUDENTSIGNIN,
    ROUTES.FORGOTPASSWORD,
    ROUTES.PARENTFORGOTPASSWORD,
    ROUTES.EMPLOYEEFORGOTPASSWORD,
    ROUTES.ADMINFORGOTPASSWORD,
    ROUTES.PARENTSIGNIN,
    ROUTES.EMPLOYEESIGNIN,
    ROUTES.ADMINSIGNIN,
    ROUTES.STUDENTVERIFYOTP,
    ROUTES.PARENTVERIFYOTP,
    ROUTES.EMPLOYEEVERIFYOTP,
    ROUTES.ADMINVERIFYOTP,
    ROUTES.REGISTRATION,
    ROUTES.PRIVACYPOLICY,
    ROUTES.TERMS,
    ROUTES.SYSTEMSETUPSCHOOL,
    ROUTES.TRIALENDED
  ];
  const hideLayout = hideSidebarRoutes.includes(location.pathname);
  const validPaths = Object.values(ROUTES);

  const isValidPath = validPaths.includes(location.pathname);

  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  const handleOutsideClick = () => {
    if (isMobile && sidebarOpen) setSidebarOpen(false);
  };

  return (
    <ThemeProvider>
      <ModalContext.Provider value={{ modalState, setModalState }}>
        {hideLayout || !isValidPath? (
          <Box
            sx={{
              backgroundColor: "background.default",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <main className="main-content" style={{ width: "100%" }}>
              {children}
            </main>
          </Box>
        ) : (
          <Box
            className="app-layout"
            sx={{
              display: "flex",
              backgroundColor: "background.maincontentBg",
              color: "background.text",
            }}
          >
            <Sidebar open={sidebarOpen} toggleSidebar={() => setSidebarOpen(!sidebarOpen)} />
            <Box
              className="main-content"
              sx={{ flex: 1, position: "relative", height: "100%" }}
            >
              <Navbar toggleSidebar={() => setSidebarOpen(!sidebarOpen)}/>

              {modalState.open && modalState.component && (
                <Box
                  sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 1210,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <ReusableModal
                    open={modalState.open}
                    onClose={() =>
                      setModalState({ open: false, component: null, props: {} })
                    }
                    {...modalState.props}
                    title={modalState.title || ""}
                    style={modalState.style || {}}
                  >
                    <ModalComponent />
                  </ReusableModal>
                </Box>
              )}

              {children}
            </Box>
          </Box>
        )}
      </ModalContext.Provider>
    </ThemeProvider>
  );
};

export default MainLayout;
